import { useStore } from 'effector-react'
import * as React from 'react'

import {
  $verifications,
  $totalCountOfVerifications,
  verificationsListMounted,
  getVerifications,
} from './model'
import { VerificationRequest } from './types'
import { $users } from '../../usersRoles/users/list/model'

export const useVerificationsList = () => {
  const onChangeVerificationsList = ({
    limit,
    page,
    orderBy,
    orderDirection,
    searchText,
    searchedColumn,
    filters,
  }: VerificationRequest) => {
    verificationsListMounted({
      limit,
      page,
      orderBy,
      orderDirection,
      searchText,
      searchedColumn,
      filters,
    })
  }

  const verifications = useStore($verifications)
  const users = useStore($users)
  const totalCountOfVerifications = useStore($totalCountOfVerifications)
  const loading = useStore(getVerifications.pending)
  return {
    verifications,
    users,
    totalCountOfVerifications,
    loading,
    onChangeVerificationsList,
  }
}
